function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import FullTestimonialsQuote from "segments/desktop/core-components/full-testimonials-quote/full-testimonials-quote";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import { MD } from "constants/sizes";
import { AUTO } from "constants/cloudinary-asset-qualities";
import YoutubeVideoWithPosterComponent from "components/core/youtube-video-with-poster/youtube-video-with-poster-component";
import { StyledTestimonialsTextAndAssetComponent } from "./testimonials-text-and-asset-component.scss";
class TestimonialsTextAndAssetComponent extends PureComponent {
    render() {
        return /*#__PURE__*/ _jsx(StyledTestimonialsTextAndAssetComponent, {
            className: "testimonials-text-and-asset-component",
            children: /*#__PURE__*/ _jsx(SideBySideTextAndAsset, _object_spread({
                replaceTextComponent: FullTestimonialsQuote
            }, this.getProps()))
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "getProps", ()=>{
            const _this_props = this.props, { youtubeWithPosterProps } = _this_props, rest = _object_without_properties(_this_props, [
                "youtubeWithPosterProps"
            ]);
            if (youtubeWithPosterProps === null || youtubeWithPosterProps === void 0 ? void 0 : youtubeWithPosterProps.videoId) {
                return _object_spread({
                    replaceAssetComponent: YoutubeVideoWithPosterComponent,
                    replaceAssetComponentProps: youtubeWithPosterProps
                }, rest);
            }
            return this.props;
        });
    }
}
export { TestimonialsTextAndAssetComponent as default };
TestimonialsTextAndAssetComponent.defaultProps = {
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: MD,
    asset: {
        position: "center",
        fitToContainer: true,
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/text-and-asset/board-with-dragged-column-in-circle.png"
        }
    },
    assetQuality: AUTO,
    fullParagraph: _object_spread({}, FullTestimonialsQuote.defaultProps)
};
